const rankingItems = [
  {
    rank: 1,
    title: '2026全国街舞大赛总决赛',
    desc: '顶尖舞者巅峰对决，创意编舞引爆全场',
    tag: '街舞',
    hot: '🔥 18.5万',
  },
  {
    rank: 2,
    title: '原创音乐人年度评选',
    desc: '百位音乐人角逐年度最佳原创作品',
    tag: '音乐',
    hot: '🔥 15.2万',
  },
  {
    rank: 3,
    title: 'AI创意设计挑战赛',
    desc: '人工智能与人类创意的精彩碰撞',
    tag: '设计',
    hot: '🔥 13.8万',
  },
  {
    rank: 4,
    title: '全国大学生摄影大赛',
    desc: '青年视角下的城市与自然之美',
    tag: '摄影',
    hot: '🔥 11.4万',
  },
  {
    rank: 5,
    title: '短视频创意挑战赛',
    desc: '30秒内的无限创意，全民参与热度爆棚',
    tag: '短视频',
    hot: '🔥 10.9万',
  },
  {
    rank: 6,
    title: '国际Cosplay大赛中国区',
    desc: '还原度与创意的终极考验',
    tag: 'Cosplay',
    hot: '🔥 8.7万',
  },
];

const rankColors: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-accent-400 text-background-50',
  3: 'bg-accent-300 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          热门排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛入口热度榜单，最受关注的大赛作品与赛事
        </p>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 cursor-pointer transition-all duration-200 hover:bg-background-100"
            >
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  rankColors[item.rank] || 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">
                  {item.desc}
                </p>
              </div>
              <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800 whitespace-nowrap flex-shrink-0">
                {item.tag}
              </span>
              <span className="text-xs text-primary-600 font-medium whitespace-nowrap flex-shrink-0 hidden sm:inline">
                {item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}